/**
 * https://github.com/stalniy/casl/tree/master/packages/casl-vue
 * acl for vue, Define the permissions of the logged user
 */
import { AbilityBuilder } from '@casl/ability';

export default AbilityBuilder.define(can => {
    can('read', 'all')
})